// extracted by mini-css-extract-plugin
module.exports = {"container":"PageNotFound_container__1onNL","pokemonsNotFound":"PageNotFound_pokemonsNotFound__cV4fa","p_pokemonNotFound":"PageNotFound_p_pokemonNotFound__3i_pC"};